import { ActivationPage } from '@f_components/auth/ActivationPage';
import { EmailReset } from '@f_components/auth/EmailReset';
import { PasswordReset } from '@f_components/auth/PasswordReset';
import { PiercedCompany } from '@f_components/auth/PiercedCompany';
import { VisibleRegistration } from '@f_components/auth/VisibleRegistration';
import AppProviders from '@f_context/index';
import '@f_styles/base.sass';
import { Suspense, useState } from 'react';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { App } from './App';

// class ErrorBoundary extends React.Component {
//   constructor(props :any) {
//     super(props);
//     this.state = { hasError: false } as Readonly<{}>;
//   }

//   static getDerivedStateFromError(error: any) {
//     // Update state so the next render will show the fallback UI.
//     return { hasError: true };
//   }

//   render() {
//     if (this.state) {
//       return <h1>Something went wrong.</h1>;
//     }

//     return this.props;
//   }
// }

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const Index = () => {
    const [alignment, setAlignment] = useState('auth');

    return (
        <CookiesProvider>
            <AppProviders>
                <Suspense fallback="Loading...">
                    <BrowserRouter>
                        <Routes>
                            <Route path="/*" element={<App alignment={alignment} setAlignment={setAlignment} />} />
                            <Route path="auth/confirm" element={<ActivationPage />} />
                            <Route path="password/reset" element={<PasswordReset />} />
                            <Route path="email/reset" element={<EmailReset />} />
                            <Route path="add/workspace" element={<PiercedCompany />} />
                            <Route
                                path="registration/24dd76e5-7cef-49bd-873d-57a6b79b734e"
                                element={<VisibleRegistration setAlignment={setAlignment} alignment={alignment} />}
                            />
                        </Routes>
                        <Toaster />
                    </BrowserRouter>
                </Suspense>
            </AppProviders>
        </CookiesProvider>
    );
};
root.render(<Index />);
